const handleMegaMenuItems = () => {
    const $menu = $('.mega-menu');

    $menu.each(function (index, el) {
        const $this = $(this);

        const $menuHeading = $this.find('.mega-menu__content h4');
        const $menuContent = $this.find('.mega-menu__items');

        $menuHeading.append('<span class="mega-menu__menu-trigger js-mega-menu-trigger"></span>');
        const $menuTrigger = $menuHeading.find('.js-mega-menu-trigger');

        $menuTrigger.on('click', function (event) {
            const $this = $(this);
            const $parent = $this.parent();

            if ($(window).width() > 1023) {
                return
            } else {
                $this.closest('.mega-menu__content')
                    .toggleClass('is-active');

                $parent.next()
                    .stop()
                    .slideToggle()
                    .closest('.mega-menu__inner')
                    .siblings()
                    .find($menuContent)
                    .slideUp();

                $this
                    .closest('.mega-menu__inner')
                    .siblings()
                    .find('.mega-menu__content')
                    .removeClass('is-active');
            }
        });
    });
};

handleMegaMenuItems();